import { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const validatePassword = (password) => {
  const rules = [
    { regex: /.{8,}/, message: 'At least 8 characters' },
    { regex: /[A-Z]/, message: 'At least 1 uppercase letter' },
    { regex: /[a-z]/, message: 'At least 1 lowercase letter' },
    { regex: /[0-9]/, message: 'At least 1 number' },
    { regex: /[^A-Za-z0-9]/, message: 'At least 1 special character' },
  ];

  const failed = rules.filter(rule => !rule.regex.test(password));
  return {
    isValid: failed.length === 0,
    errors: failed.map(f => f.message)
  };
};

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();

  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [passwordErrors, setPasswordErrors] = useState([]);
  const [matchError, setMatchError] = useState('');
  
const handlePasswordChange = (value) => {
    setNewPassword(value);
    const result = validatePassword(value);
    setPasswordErrors(result.errors);
    if (confirmPassword && value !== confirmPassword) {
      setMatchError('Passwords do not match');
    } else {
      setMatchError('');
    }
  };

const handleConfirmChange = (value) => {
    setConfirmPassword(value);
    if (newPassword && value !== newPassword) {
      setMatchError('Passwords do not match');
    } else {
      setMatchError('');
    }
  };

    const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    const { isValid, errors } = validatePassword(newPassword);
    if (!newPassword || !confirmPassword) {
      setError('Please fill in all fields.');
      return;
    }
    if (!isValid) {
      setError('Password does not meet requirements.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Passwords do not match.');
      return;
    }

    setLoading(true);

    try {
      const res = await fetch('/api/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });

      const data = await res.json();

      if (!res.ok) {
        setError(data.message || 'Failed to reset password.');
      } else {
        setMessage(data.message || 'Password reset successfully.');
       // setTimeout(() => navigate('/login'), 2000);
      }
    } catch (err) {
      setError('Something went wrong. Please try again.');
    }

    setLoading(false);
  };
  
  return (    <div className="page-container">
      <div className="content-wrap">
      <section className="navbar-area navbar-one">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg">
                <a className="navbar-brand" href="/">
                  <img width="200" height="70" src={require("../images/logo.png")} alt="Logo" />
                </a>
                <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarOne"
                  aria-controls="navbarOne" aria-expanded="false" aria-label="Toggle navigation">
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                  <span className="toggler-icon"></span>
                </button>
                <div className="collapse navbar-collapse sub-menu-bar" id="navbarOne">
                  <ul className="navbar-nav m-auto">
<li className="nav-item">
                  <a className="active page-scroll" href="/">Home</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/pricing">Pricing</a>
                </li>
                
                <li className="nav-item">
                  <a className="page-scroll" href="/referral">Refer and Win</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/faq">FAQ</a>
                </li>
                <li className="nav-item">
                  <a className="page-scroll" href="/contact">Contact Us</a>
                </li>             
              </ul>
                </div>
                <div className="navbar-btn">
                  <ul className="list-unstyled d-flex flex-wrap flex-md-row gap-2">
                    <li>
                      <a className="btn btn-primary w-100 w-md-auto" href="/signup">SIGN UP</a>
                    </li>
                  </ul>
                </div>
              </nav>
            </div>
          </div>
        </div>
      </section>

      <section id="hero-area" className="header-area header-ten">
        <div className="header-inner">
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-lg-4 co-12">
                <div className="home-slider">
                  <div className="form-container">

      <h1>Reset Password</h1>

     
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 10 }}>
          
          <input
            type="password"
            value={newPassword}
            placeholder='New Password'
            onChange={(e) => handlePasswordChange(e.target.value)}
            style={{ width: '100%', padding: 8 }}
          />
          {passwordErrors.length > 0 && (
                            <ul style={{ color: 'red', fontSize: '14px', paddingLeft: 16, marginTop: 5 }}>
                              {passwordErrors.map((err, idx) => (
                                <li key={idx}>{err}</li>
                              ))}
                            </ul>
                          )}
        </div>

<div style={{ marginBottom: 10 }}>
                          <input
                            type="password"
                            value={confirmPassword}
                            placeholder='Confirm Password'
                            onChange={(e) => handleConfirmChange(e.target.value)}
                            style={{ width: '100%', padding: 8 }}
                          />
                          {matchError && (
                            <div style={{ color: 'red', fontSize: '14px', marginTop: 5 }}>{matchError}</div>
                          )}
                        </div>
        <button
          type="submit"
          style={{ padding: '10px 20px', backgroundColor: '#155bd5', color: '#fff', border: 'none', cursor: 'pointer' }}
        >Reset Password
        </button>
        {message && <div style={{ textAlign: 'center', fontSize: '16px', marginTop: '20px', fontWeight: 'bold', color: 'green', marginBottom: 10 }}>{message}</div>}
        {error && <div style={{ textAlign: 'center', marginTop: '20px', fontSize: '16px', fontWeight: 'bold', color: 'red', marginBottom: 10 }}>{error}</div>}
      </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
<section className="footer-area footer-five">
  <div className="container">
    <div className="footer-top-content">
      
      {/* Links Section */}
      <div className="footer-links">
        <ul>
          <li>
            <a href="/terms" target="_blank" rel="noopener noreferrer">
              Terms & Conditions
            </a>
          </li>
          <li>
            <a href="/privacy" target="_blank" rel="noopener noreferrer">
              Privacy Policy
            </a>
          </li>
        </ul>
      </div>

      {/* Contact Section */}
      <div className="footer-contact">
        <h4>Contact Us:</h4>
        <a href="mailto:support@tradebarta.com">support@tradebarta.com</a>
      </div>

    </div>
  </div>

  {/* Bottom copyright section */}
  <div className="footer-copyright">
    <div className="container">
      <p className="text-center">Copyright © 2025. All Rights Reserved</p>
    </div>
  </div>
</section>
    </div>
  );
};

export default ResetPassword;